import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Button, Grid, Stack, Typography } from "@mui/material";
import { DroppableCard } from "./DroppableCard";
import {
  editUser,
  selectActiveDaoTrangId,
  selectMembers,
  setGroupChecked,
} from "../../features/daoTrang/daoTrangSlice";
import { Content } from "../Content/Content";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { setMoveToCb } from "./dragDrop";
import { updateUser } from "../../services/user/userApi";
import { CommonEdit } from "../Content/CommonEdit";

const ThanhPhan = ({ navigate, params = {} }) => {
  let { id: daoTrangId } = params;

  const dispatch = useAppDispatch();

  const activeDaoTrangId = useAppSelector(selectActiveDaoTrangId);
  const members = useAppSelector(selectMembers);
  const [dict, setDict] = useState({});

  // if navigate form memnu: daoTrangId = activeDaoTrang
  if (!daoTrangId) {
    daoTrangId = activeDaoTrangId;
  }

  useEffect(() => {
    // if navigate form memnu: daoTrangId = activeDaoTrang
    if (!daoTrangId) {
      navigate(-1);
      return;
    }

    const dict = { A: [], B: [], C: [], D: [], E: [], others: [] };
    members.forEach((u) => {
      var tp = u.thanhPhan;
      if (Object.keys(dict).includes(tp)) {
        dict[tp].push(u);
      } else {
        dict.others.push(u);
      }
    });
    setDict(dict);

    const onMoveTo = (dragTarget, dragContainer, container) => {
      console.log(dragTarget, dragContainer.name, "->", container.name)
      // dispatch(editUser({id: dragTarget.id, changes: {thanhPhan: container.name}}))
      const src = dragContainer.childs.filter(u=>u.id !== dragTarget.id);
      container.childs.push(dragTarget);
      const newDict = {...dict, [dragContainer.name]:src};
      setDict(newDict);
    };
    setMoveToCb(onMoveTo);
  }, [daoTrangId, members, navigate]);

  const onCheck = useCallback(
    (index, checked) => {
      console.log(index, checked);
      dispatch(setGroupChecked({ index, checked }));
    },
    [dispatch]
  );

  const groups = Object.keys(dict).map((key) => ({
    name: key,
    childs: dict[key],
  }));

  const onSave = useCallback(() => {
    try {
      groups.forEach(g=>{
        if (g.name === "others") return;
        const thanhPhan = g.name === "others"?"":g.name;
        g.childs.forEach(async u=>{
          if (u.thanhPhan !== thanhPhan) {
            console.log(u.email, u.thanhPhan, "->", thanhPhan);
            const changes = {thanhPhan};
            const {error} = await updateUser(u.id, changes);
            if (!error) {
              dispatch(editUser({id:u.id, changes}));
            }
          }
        })
      })
    } catch (ex) {
      console.log(ex.message);
    }
  }, [dispatch, groups]);

  return (
    <CommonEdit text={"Thành Phần"} onSave={onSave} oncancel={()=>navigate(-1)}>
      <Grid
        container
        sx={{
          // minWidth: 600,
          // minHeight: 400,
          overflow: "auto",
          // flexDirection: "column",
          // justifyContent: "center",
          // width: "100%",
          height: "100%",
          // maxWidth: "100%",
        }}
      >
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          
          flexWrap="wrap"
          justifyContent="center"
        >
          <DndProvider backend={HTML5Backend}>
            {groups.map((g, i) => (
              <DroppableCard
                group={g}
                index={i}
                key={i}
                onCheck={onCheck}
                navigate={navigate}
              />
            ))}
          </DndProvider>
        </Stack>
      </Grid>
    </CommonEdit>
  );
};

export default ThanhPhan;
